module.exports = __webpack_public_path__ + "img/qhjbh_intro.cf68352f.png";